import { translation } from '../core';
import type { fr } from './fr';

export const en = translation<typeof fr>()({
  vehicle: 'Vehicle',
  experience: 'Experience',
  customer: 'Customer',
  partnerAgency: 'Partner agency',
  verifiedAgency: 'Verified partner agency',
  verifiedAgencyIn: 'Verified partner agency · {city}',
  verifiedProvider: 'Verified provider',
  blogCategory: 'Tips',
  ticket: 'Ticket',

  'transmission.manual': 'Manual',
  'transmission.automatic': 'Automatic',
  'fuel.diesel': 'Diesel',
  'fuel.petrol': 'Petrol',
  'fuel.hybrid': 'Hybrid',
  'fuel.electric': 'Electric',
  availabilityConfirmed: 'Availability confirmed',
  'mileage.perDay': '{km} km / day',
  'mileage.extraCharged': 'Beyond {km} km per day, the agency charges {price} MAD for each extra kilometre.',
  'mileage.included': 'Mileage included: {km} km per day.',
  'mileage.unknown': 'Mileage set by the agency',
  'included.mileage': 'Extra kilometres charged by the agency',
  'included.cancel.title': 'Free cancellation',
  'included.cancel.text': 'Up to 48 h before departure',
  'included.support.title': '24/7 support',
  'included.support.text': 'By chat and WhatsApp',
  'included.delivery.title': 'Delivery available',
  'included.delivery.free': 'Free, to your address',
  'included.delivery.paid': 'To your address, depending on the agency',
  'city.vehicles': { one: '{count} vehicle', other: '{count} vehicles' },
  'city.experiences': { one: '{count} experience', other: '{count} experiences' },
  'agency.description.delivery':
    'Cardnd partner agency in {city}. Book online: the agency confirms and hands you the vehicle at the agency or at your address.',
  'agency.description.agency':
    'Cardnd partner agency in {city}. Book online: the agency confirms and hands you the vehicle at the agency.',

  'place.departure': 'Departing from {city}',
  'place.delivery': 'Delivery',
  'place.deliveryTo': 'Delivery · {address}',
  'place.agencyPickup': 'Pickup at the agency · {city}',

  'line.rental': 'Rental',
  'line.rentalDays': 'Rental · {days}',
  'line.longStay': 'Long-stay discount ({pct}%)',
  'line.delivery': 'Delivery to your address',
  'line.agencyPickup': 'Pickup at the agency',
  'line.free': 'Free',
  'line.included': 'Included',
  'line.group': { one: 'Group · {count} person', other: 'Group · {count} people' },
  'line.option': 'Extra',
  'line.pickup': 'Pickup',
  'line.adjustment': 'Adjustment',
  'line.seasonal': 'Seasonal rate',
  'participants.adult': 'Adults',
  'participants.child': 'Children',
  'participants.infant': 'Infants',
  'participants.free': { one: '{label} · {count} free', other: '{label} · {count} free' },
  'participants.paying.adult': { one: '{count} paying adult', other: '{count} paying adults' },
  'participants.paying.child': { one: '{count} paying child', other: '{count} paying children' },
  'participants.paying.infant': { one: '{count} paying infant', other: '{count} paying infants' },
  'participants.count.child': { one: '{count} child', other: '{count} children' },
  'participants.count.infant': { one: '{count} infant', other: '{count} infants' },

  'difficulty.easy': 'Easy',
  'difficulty.moderate': 'Moderate',
  'difficulty.challenging': 'Challenging',
  'difficulty.hard': 'Difficult',
  'cancellation.flexible': 'Flexible cancellation',
  'cancellation.moderate': 'Moderate cancellation',
  'cancellation.strict': 'Strict cancellation',
  'cancellation.hours': 'Full refund up to {hours} h before',
  'cancellation.provider': 'Provider’s cancellation terms',
  'duration.minutes': '{minutes} min',
  'duration.hours': '{hours} h',
  'duration.hoursMinutes': '{hours} h {minutes} min',
  'group.private': 'Private group',
  'group.upTo': 'Up to {count} people',
  'mode.circuit.private': 'Private tour',
  'mode.circuit.shared': 'Shared tour',
  'mode.transfer.private': 'Private transfer',
  'mode.transfer.shared': 'Shared transfer',
  'mode.excursion.private': 'Private excursion',
  'mode.excursion.shared': 'Shared excursion',

  'refundTerms.hours': 'Full refund up to {hours} h before departure, no refund after that.',
  'refundTerms.flexible': 'Full refund up to 24 h before departure, no refund after that.',
  'refundTerms.moderate': 'Full refund up to 48 h before departure, 50% up to 24 h before, no refund after that.',
  'refundTerms.strict': 'Full refund up to 7 days before departure, no refund after that.',
  'refundTerms.provider': 'The refund follows the provider’s cancellation terms.',
  'refund.untilStart': 'Until departure',
  'refund.until': 'Until {when}',
  'refund.after': 'After that',
  'refund.lastDay': 'Less than 24 h before',
  'refund.full': 'Full refund',
  'refund.minusFee': 'Refunded minus the service fee',
  'refund.half': '50% refunded',

  'thread.support': 'Cardnd support',
  'thread.supportSubtitle': '24/7 support',
  'thread.yourBooking': 'Your booking',

  'ics.summary': '{title} rental · Cardnd',
  'ics.vehicle':
    'Booking {ref}. Show your QR voucher and PIN code at the agency, with your driving licence and an ID document.',
  'ics.experience': 'Booking {ref} · show your QR voucher to the guide.',
  'support.whatsapp': 'Hello CARDND, I need help with my booking request {reference}.',
});
